import { AuthToken } from './../../graphql/types/types.d';
import { IStore } from '../IStore';

export const selectLoggedIn = (state: IStore): boolean | undefined => state.auth.loggedIn;
export const selectLoginRedirectPath = (state: IStore): string | undefined =>
  state.auth.loginRedirectPath;
export const selectFirstToken = (state: IStore): string | undefined => state.auth.firstToken;
export const selectAuthToken = (state: IStore): AuthToken | undefined => state.auth.authToken;
export const selectTimeoutTimestamp = (state: IStore): Date | undefined =>
  state.auth.timeoutTimestamp;
export const selectRemainingTime = (state: IStore): number | undefined => state.auth.remainingTime;
export const selectLoginErrors = (state: IStore): { [key: string]: string | undefined } =>
  state.auth.loginErrors;
export const selectFinishedConfirmation = (state: IStore): boolean =>
  state.auth.finishedConfirmation;
export const selectShouldResetClient = (state: IStore): boolean => state.auth.shouldResetClient;
export const selectLanguage = (state: IStore): string | undefined => state.auth.language;
